import { createSelector } from 'reselect';
import { getObjValue } from 'utils/functions';
import { getDDERequiredFields } from 'selectors/assessment/selector';

const getSeachParams = props => getObjValue(props, 'history.location.search', '');

const getPOJOFromSeachParams = createSelector(getSeachParams, search => {
  const qp = new URLSearchParams(search);
  let assignees = [];
  let unassigned = 'false';
  let answered = null;
  let required = null;

  if (qp.has('assignees') && qp.get('assignees').length > 0) {
    assignees = qp.get('assignees').split(',');
  }

  if (qp.has('unassigned') && qp.get('unassigned') === 'true') {
    unassigned = qp.get('unassigned');
  }

  if (qp.has('answered') && (qp.get('answered') === 'true' || qp.get('answered') === 'false')) {
    answered = qp.get('answered');
  }

  if (qp.has('required') && (qp.get('required') === 'true' || qp.get('required') === 'false')) {
    required = qp.get('required');
  }

  return { assignees, unassigned, answered, required };
});

const getQueryFilterVariables = createSelector([getPOJOFromSeachParams, getDDERequiredFields], (filters, ddeRequired) => {
  // If filters used then the following variables are required:
  // required: assignees & unassigned
  const ddeRequiredFields = ddeRequired?.map(field => field.id);
  const { assignees, unassigned, answered, required } = filters;
  if (answered || required) {
    return { assignees, unassigned, answered, required, ddeRequiredFields };
  }
  if (assignees.length === 0 && unassigned === 'false') {
    return null;
  }
  return { assignees, unassigned, answered, required, ddeRequiredFields };
});

const getAssessmentFilters = createSelector([getPOJOFromSeachParams], qpFilters => {
  const { assignees, unassigned, answered, required } = qpFilters;
  const filters = {
    assignees: [...assignees],
    answered: [],
    required: []
  };

  if (answered) {
    filters.answered.push(answered);
  }

  if (required) {
    filters.required.push(required);
  }

  if (unassigned === 'true') {
    filters.assignees.push('unassigned');
  }
  return filters;
});

export { getSeachParams, getPOJOFromSeachParams, getQueryFilterVariables, getAssessmentFilters };
